<template>
  <div class="container">
    <content-header :data="[{text:'商品分类', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <el-button type="primary" icon="plus" @click="initNewHandle">添加一级分类</el-button>
      </div>
      <div class="new-wrap">
        <el-dialog :title="curId ? '编辑分类' : '新建下级分类'" size="tiny" :visible.sync="isNewShow">
          <el-form :model="newObj" ref="newObjForm">
            <el-form-item label="名称" :label-width="formLabelWidth">
              <el-input v-model="newObj.name" placeholder="请输入分类名称" auto-complete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelHandle">取 消</el-button>
            <el-button type="primary" @click="confirmHandle">确 定</el-button>
          </div>
          </el-upload>
        </el-dialog>
      </div>

      <div class="content-list">
        <div class="entry-box" v-if="category_tree.length">
          <div class="entry-contain bordert">
            <el-input class="entry-filter"
              placeholder="输入关键字进行过滤"
              v-model="filterText">
            </el-input>
            <el-tree class="entry-tree"
              ref="pointTree"
              node-key="id"
              default-expand-all
              highlight-current
              :expand-on-click-node="false"
              :data="category_tree"
              :props="defaultProps"
              :filter-node-method="filterNode"
              :render-content="renderContent"
              @node-click="">
            </el-tree>
          </div>
        </div>
        <div class="entry-none" v-else>
          <p>暂无分类数据</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import CategoryModel from 'models/category'
  import { mapState } from 'vuex'

  export default {
    data () {
      return {
        filterText: '',
        category_tree: [],
        defaultProps: {
          children: 'child',
          label: 'name'
        },
        curId: '',
        pid: 0,
        formLabelWidth: '50px',
        isNewShow: false,
        newObj: {name: ''},
      }
    },
    watch: {
      filterText (val) {
        this.$refs.pointTree.filter(val)
      }
    },
    created () {
      this.getTreeData()
    },
    computed: {
      ...mapState({
        userInfo: state => state.user.info
      }),
    },
    methods: {
      getTreeData () {
        CategoryModel.find().then(res => {
          this.category_tree = res.category_tree
        })
      },
      filterNode (value, data) {
        if (!value) return true
        return data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
      },
      deleteHandle (node, data, store) {
        if (data.child.length > 0) {
          this.$message({ message: '请先删除下级分类', type: 'error' })
          return
        }
        this.$confirm('确认删除 ' + node.label + '？')
          .then(_ => {
            CategoryModel.delete({
              id: data.id
            }).then(() => {
              const child = this.curChild(data.pid)
              if (child !== null) {
                for (let i = 0; i < child.length; i++) {
                  if (child[i].id === data.id) {
                    child.splice(i, 1)
                    this.$message({ message: '删除成功', type: 'success' })
                  }
                }
              }
            })
          })
          .catch(_ => {})
      },
      initNewHandle (node, data, store) {
        this.curId = ''
        this.pid = 0
        this.newObj.name = ''
        if (data) {
          this.pid = data.id
        }
        this.isNewShow = true
      },
      initEditHandle (node, data, store) {
        this.curId = data.id
        this.pid = data.pid
        this.newObj.name = data.name
        this.isNewShow = true
      },
      renderContent (h, { node, data, store }) {
        return h('span', { attrs: { style: 'flex: 1;display: flex; align-items: center;justify-content: space-between;padding-right: 8px;' } }, [
          h('span', [node.label]),
          h('span', [
            h('i', { style: 'margin-left: 20px; vertical-align: middle', class: 'iconfont icon-add', on: { click: () => this.initNewHandle(node, data, store) } }),
            h('i', { style: 'margin-left: 20px; vertical-align: middle', class: 'iconfont icon-edit', on: { click: () => this.initEditHandle(node, data, store) } }),
            h('i', { style: 'margin-left: 20px; vertical-align: middle', class: 'iconfont icon-delete', on: { click: () => this.deleteHandle(node, data, store) } }),
          ])
        ])
      },
      cancelHandle () {
        console.log('cancel')
        this.isNewShow = false
      },
      confirmHandle () {
        if (!this.newObj.name) {
          this.$message({ message: '请输入分类名称', type: 'error' })
          return
        }
        const child = this.curChild(this.pid)
        if (child !== null) {
          for (let i = 0; i < child.length; i++) {
            if (child[i].name === this.newObj.name && (child[i].id !== this.curId || this.curId === '')) {
              this.$message({ message: '同一级分类下名称不能重复', type: 'error' })
              return
            }
          }
        }
        if (this.curId) return this.editHandle()
        this.newHandle()
      },
      newHandle () {
        CategoryModel.create({
          name: this.newObj.name,
          pid: this.pid
        }).then(res => {
          // 给当前节点添加子节点
          const child = this.curChild(this.pid)
          if (child !== null) {
            child.unshift({
              id: res,
              name: this.newObj.name,
              pid: this.pid,
              child: []
            })
            this.$message({ message: '添加成功', type: 'success' })
          } else {
            this.$message({ message: '添加失败：pid=' + this.pid, type: 'error' })
          }
        }).catch(err => {
          this.$message({ message: err, type: 'error' })
        })
        this.isNewShow = false
      },
      curChild (id) {
        if (id === 0) return this.category_tree

        function findChild (id, items) {
          for (let i = 0; i < items.length; i++) {
            let item = items[i]
            if (item.id === id) { // found
              return item.child
            }
            let child = findChild(id, item.child)
            if (child !== null) return child
          }
          return null
        }
        return findChild(id, this.category_tree)
      },
      curCategory (id) {
        function findPoint (id, items) {
          for (let i = 0; i < items.length; i++) {
            let item = items[i]
            if (item.id === id) { // found
              return item
            }
            let point = findPoint(id, item.child)
            if (point !== null) return point
          }
          return null
        }
        return findPoint(id, this.category_tree)
      },
      editHandle () {
        CategoryModel.update({
          id: this.curId,
          name: this.newObj.name,
          pid: this.pid
        }).then(res => {
          const point = this.curCategory(this.curId)
          point.name = this.newObj.name
          this.$message({ message: '更新成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err, type: 'error' })
        })
        this.isNewShow = false
      },
    },
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .entry-box
        width:100%
        .entry-contain
          min-height: 36px
          &.bordert
            border-top: 1px solid #e6e6e6
          .entry-filter
            margin-bottom: 20px
          .entry-tree
            min-height: 600px
    .new-wrap
      .el-input
        width: 85%
</style>



// WEBPACK FOOTER //
// src/views/Category.vue